/**
 * Author:xiaolong.xu
 * Desc:作品库
 * Date:2022-09-13
 */
import * as React from 'react'
import classNames from 'classnames'
import { useTranslation } from '@/libs/next-lang';
import { IconSvg } from '@/components'
import { AuthorizedButton } from '@/components/Authorized'
import styles from './index.module.less'

export default function SidebarLayout({ menus, pathname, onChange, children }: any) {
  const { t } = useTranslation(['header'])

  return (
    <div className={styles['sidebar-layout']}>
      <div className={styles.menu}>
        {menus.map((item: any) => (
          <AuthorizedButton key={item.value} code={item.code} useOpacity={false}>
            <div className={styles['menu-item-li']}>
              <div
                className={classNames(styles['menu-item'], {
                  [styles.active]: pathname === item.value,
                })}
                onClick={() => onChange(item.value)}
              >
                <IconSvg type={item.icon} style={{ marginRight: 8 }} />
                <span>{t(item.translateKey)}</span>
              </div>
            </div>
          </AuthorizedButton>
        ))}
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  )
}
